import { useAuthService } from '@invivodf/front-seller-auth'
import { buildCallerId } from '@invivodf/front-seller-caller-id'
import sdk, { DeliveryModeEntity, LogisticDeliveryModeSDK } from '@invivodf/module-logistic-delivery-mode-sdk'

class DeliveryModeRepository {
  private logisticDeliveryModeSDK: LogisticDeliveryModeSDK

  constructor({ logisticApiHost }) {
    this.logisticDeliveryModeSDK = sdk(logisticApiHost, {
      callerId: buildCallerId(),
      accessTokenSource: () => useAuthService().getAccessToken(),
    })
  }

  getAll(sellerId: string): Promise<DeliveryModeEntity[]> {
    return this.logisticDeliveryModeSDK.getLogisticDeliveryModes(sellerId)
  }
}

export default DeliveryModeRepository
